import {
    GET_ADMINS,
    GET_ADMINS_SUCCESS,
    GET_ADMINS_FAILURE,
    UPDATE_ADMIN_STATUS,
    UPDATE_ADMIN_STATUS_SUCCESS,
    UPDATE_ADMIN_STATUS_FAILURE,
    DELETE_ADMIN,
    DELETE_ADMIN_SUCCESS,
    DELETE_ADMIN_FAILURE,
    ADD_ADMIN,
    ADD_ADMIN_SUCCESS,
    ADD_ADMIN_FAILURE,
    EDIT_ADMIN,
    EDIT_ADMIN_SUCCESS,
    EDIT_ADMIN_FAILURE,
    RESET_PASSWORD_ADMIN,
    RESET_PASSWORD_ADMIN_SUCCESS,
    RESET_PASSWORD_ADMIN_FAILURE,
    GET_MODULES,
    GET_MODULES_SUCCESS,
    GET_MODULES_FAILURE
} from "../Constants";

const init = {
    data: {},
    update_data: {},
    delete_data: {},
    add_data: {},
    edit_data: {},
    modules_data:{},
    reset_data:{}
};

const AdminReducer = (state = init, action) => {
    switch (action.type) {
        case GET_ADMINS:
            return { ...state, loading: true };
        case GET_ADMINS_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_ADMINS_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case UPDATE_ADMIN_STATUS:
            return { ...state, loading: true };
        case UPDATE_ADMIN_STATUS_SUCCESS:
            return { ...state, loading: false, update_data: action.payload };
        case UPDATE_ADMIN_STATUS_FAILURE:
            return { ...state, loading: false, update_data: action.payload };
        case DELETE_ADMIN:
            return { ...state, loading: true };
        case DELETE_ADMIN_SUCCESS:
            return { ...state, loading: false, delete_data: action.payload };
        case DELETE_ADMIN_FAILURE:
            return { ...state, loading: false, delete_data: action.payload };
        case ADD_ADMIN:
            return { ...state, loading: true };
        case ADD_ADMIN_SUCCESS:
            return { ...state, loading: false, add_data: action.payload };
        case ADD_ADMIN_FAILURE:
            return { ...state, loading: false, add_data: action.payload };
        case EDIT_ADMIN:
            return { ...state, loading: true };
        case EDIT_ADMIN_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_ADMIN_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        case RESET_PASSWORD_ADMIN:
            return { ...state, loading: true };
        case RESET_PASSWORD_ADMIN_SUCCESS:
            return { ...state, loading: false, reset_data: action.payload };
        case RESET_PASSWORD_ADMIN_FAILURE:
            return { ...state, loading: false, reset_data: action.payload };
        case GET_MODULES:
            return { ...state, loading: true };
        case GET_MODULES_SUCCESS:
            return { ...state, loading: false, modules_data: action.payload };
        case GET_MODULES_FAILURE:
            return { ...state, loading: false, modules_data: action.payload };
        default:
            return state;
    }
};

export default AdminReducer;